export enum UserPermission {
  ADMINISTRATORS = 'administrators',
  CAN_MANAGE_GROUPS = 'can_manage_groups',
  CAN_MANAGE_USERS = 'can_manage_users',
  CAN_MANAGE_ACCOUNTING = 'can_manage_accounting',
  CAN_VIEW_USERS = 'can_view_users',
  CAN_MANAGE_TERMINATION_INSURANCES = 'can_manage_termination_insurances',
  CAN_MANAGE_TAKE_OVER_INSURANCES = 'can_manage_take_over_insurances',
  CAN_VIEW_MR_MONEY_TOKEN = 'can_view_mr_money_token'
}
